<template>
  <lida-table
    :propscolumns="columns"
    :data="gametotalItems"
    :sortStatus="false"
    align="right"
    :SpinLoading="loading"
    :propsPageSize="50"
    :LeaveSpace="false"
  >
    <template v-slot:headerSelect>
      <p class="title text-left">全部</p>
    </template>
  </lida-table>
</template>
<script>
import { mapGetters } from 'vuex'
import NP from 'number-precision'
import { ToDecimal } from 'utils';
import reportCount from '@/mixins/report-count.js'
import totalData from 'utils/table-total-data'
import switchHie from "../mixins/switchHie.js"
export default {
  name: 'report-frist-tatal',
  mixins: [reportCount, switchHie],
  props: {
    objectdata: {
      type: Object,
    }
  },
  data () {
    return {
      gametotalItems: [],
      notSunArray: ['betcalid', 'date', 'gameid', 'bpname', 'deoddsrepname', 'mark', 'odds', 'username', 'wilo', 'period'],
      loading: false,
      totalArr: {
        yokekka: "",
        lpds: ""
      }
    }
  },
  computed: {
    ...mapGetters(['lidaTableCheck']),
    columns () {
      const object = {
        gameid: {
          title: '游戏项目',
          align: 'center',
          key: 'gameid',
          width: 120,
          totaltext: '总计',
          render: (h, params) => {
            if (params.row.gameid == '总计') return h('p', params.row.gameid)

            const gameid = params.row.gameid || this.query.gameid
            const list = this.getalllist.find(it => it.gameid == gameid)
            return h('p', list.gamename)
          },
        },
        cou: {
          title: '注数',
          align: 'center',
          key: 'cou',
          width: 50,
          total: true,
        },
        value: {
          title: '下注金额',
          align: 'center',
          key: 'value',
          total: true,
          minWidth: 60,
          render: (h, params) => this.renderColorAmount(h, params, 'value')
        },
        // duishei: {
        //   title: '退水',
        //   align: 'center',
        //   key: 'duishei',
        //   width: 100,
        // },
        bonuswin: {
          title: '派彩金額',
          align: 'center',
          key: 'bonuswin',
          total: true,
          minWidth: 30,
          render: (h, params) => {
            if (!this.judgeExgame(Number(params.row.gameid)) ) {
              return h('p', 'X')
            } else {
              return this.renderColorAmount(h, params, 'bonuswin')
            }
          }
        },
        bonus: {
          title: '奖金',
          align: 'center',
          key: 'bonus',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          minWidth: 30,
          render: (h, params) => {
            if (Number(params.row.gameid) == 101) {
              return h('p', 'X')
            } else {
              return this.renderColorAmount(h, params, 'bonus')
            }
          }
        },
        payds: {
          title: '佣金',
          align: 'center',
          key: 'payds',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'payds')
        },
        kekka: {
          title: '结果',
          align: 'center',
          key: 'kekka',
          total: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'kekka')
        },
        yokekka: {
          title: '您的结果',
          align: 'center',
          key: 'yokekka',
          total: true,
          minWidth: 30,
          render: (h, params) => {
            if (params.row.gameid !== '总计') {
              return h('div', [
                this.renderColorAmount(h, params, 'yokekka'),
                this.renderColorAmount(h, params, 'lpds')
              ])
            } else {
              return h('div', [
                h('p', this.NegativeColor(this.totalArr.yokekka), this.toDecimal2(this.totalArr.yokekka)),
                h('p', this.NegativeColor(this.totalArr.lpds), this.toDecimal2(this.totalArr.lpds))
              ])
            }
          }
        },
      }
      return object
    },
  },
  watch: {
    objectdata: {
      handler (val) {
        this.sunGameTotal(val)
      }
    }
  },
  created () {
    this.loading = true
  },
  methods: {
    sunGameTotal ({ data }) { // 总计table
      this.loading = true
      this.totalArr = { yokekka: "", lpds: "" }
      if (!Object.keys(this.objectdata).length) return
      const array = Object.keys(data).reduce((acc, val) => {
        acc[val] = data[val].reduce((acc2, val2) => {
          const keys = Object.keys(val2)
          keys.forEach(it => {
            if (it in acc2 == false) acc2[it] = 0
            if (this.some(this.notSunArray, it)) {
              acc2[it] = NP.plus(parseFloat(acc2[it]).toFixed(4), parseFloat(val2[it]).toFixed(4))
            } else {
              acc2[it] = val2[it]
            }
            if (val == 101 && it == 'bonus') acc2[it] = 0 // 過濾電子遊戲的獎金欄位
            acc2.cou = data[val].length
          });
          return acc2
        }, {})
        this.totalArr = totalData(data[val], this.totalArr)
        return acc
      }, {})
      this.gametotalItems = Object.values(array)
      this.loading = false
    },
    judgeExgame(gameid) { // 判斷外站遊戲
      return gameid >= 101 && gameid <= 200
    }
  }
}
</script>